import { dynamicPage } from '@meteor/dynamic-component';
import { NotFound } from '@meteor/pages';
import { ModalRoot, Toaster } from '@meteor/ui';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { RootLayout } from './layout/rootLayout';
import { AnalyticsInitializer } from './lib/analytics';
import { IndexRedirect } from './pages';
import { RouterErrorPage } from './pages/_error/routerError';
import { InstanceRedirect } from './pages/instance';

let InstanceHomePage = dynamicPage(() =>
  import('./pages/(instance-workflows)').then(m => m.InstanceHomePage)
);
let InstanceDataPageLayout = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/_layout').then(m => m.InstanceDataPageLayout)
);
let InstanceGroupsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/groups').then(m => m.InstanceGroupsPage)
);
let InstanceGroupOverviewPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/groups/[groupId]').then(
    m => m.InstanceGroupOverviewPage
  )
);
let InstanceGroupLayoutPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/groups/[groupId]/_layout').then(
    m => m.InstanceGroupLayoutPage
  )
);
let GroupThreadsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/groups/[groupId]/threads').then(
    m => m.GroupThreadsPage
  )
);
let GroupUsersPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/groups/[groupId]/users').then(
    m => m.GroupUsersPage
  )
);
let InstanceRunsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/runs').then(m => m.InstanceRunsPage)
);
let InstanceStatisticsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/statistics').then(m => m.InstanceStatisticsPage)
);
let InstanceThreadsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/threads').then(m => m.InstanceThreadsPage)
);
let InstanceThreadPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/threads/[threadId]').then(
    m => m.InstanceThreadPage
  )
);
let InstanceThreadLayoutPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/threads/[threadId]/_layout').then(
    m => m.InstanceThreadLayoutPage
  )
);
let InstanceThreadFlowPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/threads/[threadId]/flow').then(
    m => m.InstanceThreadFlowPage
  )
);
let InstanceThreadParticipantsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/threads/[threadId]/participants').then(
    m => m.InstanceThreadParticipantsPage
  )
);
let InstanceThreadRunsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/threads/[threadId]/runs').then(
    m => m.InstanceThreadRunsPage
  )
);
let InstanceUsersPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/users').then(m => m.InstanceUsersPage)
);
let InstanceUserPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/users/[userId]').then(m => m.InstanceUserPage)
);
let InstanceUserLayoutPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/users/[userId]/_layout').then(
    m => m.InstanceUserLayoutPage
  )
);
let InstanceUserGroupsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/(data)/users/[userId]/groups').then(
    m => m.InstanceUserGroupsPage
  )
);
let InstancePageLayout = dynamicPage(() =>
  import('./pages/(instance-workflows)/_layout').then(m => m.InstancePageLayout)
);
let InstanceAgentsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents').then(m => m.InstanceAgentsPage)
);
let InstanceAgentOverviewPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/[agentId]').then(
    m => m.InstanceAgentOverviewPage
  )
);
let InstanceAgentLayoutPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/[agentId]/_layout').then(
    m => m.InstanceAgentLayoutPage
  )
);
let InstanceAgentBuilderPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/[agentId]/builder').then(
    m => m.InstanceAgentBuilderPage
  )
);
let InstanceAgentReleasesPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/[agentId]/releases').then(
    m => m.InstanceAgentReleasesPage
  )
);
let InstanceAgentRunsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/[agentId]/runs').then(
    m => m.InstanceAgentRunsPage
  )
);
let InstanceAgentSettingsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/[agentId]/settings').then(
    m => m.InstanceAgentSettingsPage
  )
);
let InstanceAgentsPageLayout = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/_layout').then(m => m.InstanceAgentsPageLayout)
);
let InstanceAgentsChoosePage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/choose').then(m => m.InstanceAgentsChoosePage)
);
let InstanceAgentConnectionsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/connections').then(
    m => m.InstanceAgentConnectionsPage
  )
);
let InstanceAgentTemplatesPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/agents/templates').then(
    m => m.InstanceAgentTemplatesPage
  )
);
let InstanceConnectionsOverviewPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/[connectionId]').then(
    m => m.InstanceConnectionsOverviewPage
  )
);
let InstanceConnectionLayoutPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/[connectionId]/_layout').then(
    m => m.InstanceConnectionLayoutPage
  )
);
let InstanceConnectionsAccessPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/[connectionId]/access').then(
    m => m.InstanceConnectionsAccessPage
  )
);
let InstanceConnectionsConfigurationPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/[connectionId]/configuration').then(
    m => m.InstanceConnectionsConfigurationPage
  )
);
let InstanceConnectionsSettingsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/[connectionId]/settings').then(
    m => m.InstanceConnectionsSettingsPage
  )
);
let InstanceConnectionOauthCallbackPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/_oauth/callback').then(
    m => m.InstanceConnectionOauthCallbackPage
  )
);
let InstanceConnectionChoosePage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/choose').then(
    m => m.InstanceConnectionChoosePage
  )
);
let InstanceConnectionSetPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/connections/set').then(m => m.InstanceConnectionSetPage)
);
let InstanceDeveloperPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/developer').then(m => m.InstanceDeveloperPage)
);
let InstanceDeveloperLogsLayoutPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/developer/(logs)/_layout').then(
    m => m.InstanceDeveloperLogsLayoutPage
  )
);
let InstanceDeveloperPageLayout = dynamicPage(() =>
  import('./pages/(instance-workflows)/developer/_layout').then(
    m => m.InstanceDeveloperPageLayout
  )
);
let InstanceDeveloperAPIPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/developer/api').then(m => m.InstanceDeveloperAPIPage)
);
let InstanceDeveloperEnvironmentsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/developer/environments').then(
    m => m.InstanceDeveloperEnvironmentsPage
  )
);
let InstancePortalsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals').then(m => m.InstancePortalsPage)
);
let InstancePortalOverviewPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]').then(
    m => m.InstancePortalOverviewPage
  )
);
let InstancePortalLayoutPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/_layout').then(
    m => m.InstancePortalLayoutPage
  )
);
let InstancePortalAgentsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/agents').then(
    m => m.InstancePortalAgentsPage
  )
);
let InstancePortalBrandingPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/branding').then(
    m => m.InstancePortalBrandingPage
  )
);
let InstancePortalDomainsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/domains').then(
    m => m.InstancePortalDomainsPage
  )
);
let InstancePortalEnvironmentsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/environments').then(
    m => m.InstancePortalEnvironmentsPage
  )
);
let InstancePortalSettingsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/settings').then(
    m => m.InstancePortalSettingsPage
  )
);
let InstancePortalSettingsLayout = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/settings/_layout').then(
    m => m.InstancePortalSettingsLayout
  )
);
let InstancePortalSettingsAuthPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/[portalId]/settings/auth').then(
    m => m.InstancePortalSettingsAuthPage
  )
);
let InstancePortalsPageLayout = dynamicPage(() =>
  import('./pages/(instance-workflows)/portals/_layout').then(m => m.InstancePortalsPageLayout)
);
let InstanceSettingsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/settings').then(m => m.InstanceSettingsPage)
);
let InstanceSettingsPageLayout = dynamicPage(() =>
  import('./pages/(instance-workflows)/settings/_layout').then(
    m => m.InstanceSettingsPageLayout
  )
);
let InstanceSettingsEnvironmentsPage = dynamicPage(() =>
  import('./pages/(instance-workflows)/settings/environments').then(
    m => m.InstanceSettingsEnvironmentsPage
  )
);
let AccountPage = dynamicPage(() => import('./pages/account').then(m => m.AccountPage));
let AccountPageLayout = dynamicPage(() =>
  import('./pages/account/_layout').then(m => m.AccountPageLayout)
);
let AccountEmailsPage = dynamicPage(() =>
  import('./pages/account/emails').then(m => m.AccountEmailsPage)
);
let AccountSecurityPage = dynamicPage(() =>
  import('./pages/account/security').then(m => m.AccountSecurityPage)
);
let OrganizationPage = dynamicPage(() => import('./pages/o').then(m => m.OrganizationPage));
let OrganizationTeamLayout = dynamicPage(() =>
  import('./pages/o/(team)/_layout').then(m => m.OrganizationTeamLayout)
);
let OrganizationInvitesPage = dynamicPage(() =>
  import('./pages/o/(team)/invite').then(m => m.OrganizationInvitesPage)
);
let OrganizationMembersPage = dynamicPage(() =>
  import('./pages/o/(team)/members').then(m => m.OrganizationMembersPage)
);
let OrganizationPageLayout = dynamicPage(() =>
  import('./pages/o/_layout').then(m => m.OrganizationPageLayout)
);
let OrganizationBillingPage = dynamicPage(() =>
  import('./pages/o/billing').then(m => m.OrganizationBillingPage)
);
let OrganizationProjectsPage = dynamicPage(() =>
  import('./pages/o/projects').then(m => m.OrganizationProjectsPage)
);
let OrganizationInvitePage = dynamicPage(() =>
  import('./pages/orgInvite').then(m => m.OrganizationInvitePage)
);
let WelcomePage = dynamicPage(() => import('./pages/welcome').then(m => m.WelcomePage));
let WelcomeCreateProjectPage = dynamicPage(() =>
  import('./pages/welcome/create-project').then(m => m.WelcomeCreateProjectPage)
);
let WelcomeProjectPage = dynamicPage(() =>
  import('./pages/welcome/project').then(m => m.WelcomeProjectPage)
);

let router = createBrowserRouter([
  {
    path: '/',
    element: (
      <>
        <Outlet />
        <Toaster />
        <ModalRoot />
        <AnalyticsInitializer />
      </>
    ),
    errorElement: <RouterErrorPage />,
    children: [
      {
        path: '',
        element: <RootLayout />,
        children: [
          {
            path: '',
            element: <IndexRedirect />
          },

          {
            path: 'organization-invite',
            element: <OrganizationInvitePage />
          },

          {
            path: 'welcome',
            children: [
              {
                path: '',
                element: <WelcomePage />
              },
              {
                path: 'project',
                element: <WelcomeProjectPage />
              },
              {
                path: 'create-project',
                element: <WelcomeCreateProjectPage />
              }
            ]
          },

          {
            path: 'account',
            element: <AccountPageLayout />,
            children: [
              {
                path: '',
                element: <AccountPage />
              },
              {
                path: 'emails',
                element: <AccountEmailsPage />
              },
              {
                path: 'security',
                element: <AccountSecurityPage />
              }
            ]
          },

          {
            path: 'o/:organizationId',
            element: <OrganizationPageLayout />,
            children: [
              {
                path: '',
                element: <OrganizationPage />
              },

              {
                path: 'billing',
                element: <OrganizationBillingPage />
              },

              {
                path: 'projects',
                element: <OrganizationProjectsPage />
              },

              {
                element: <OrganizationTeamLayout />,

                children: [
                  {
                    path: 'members',
                    element: <OrganizationMembersPage />
                  },

                  {
                    path: 'invites',
                    element: <OrganizationInvitesPage />
                  }
                ]
              }
            ]
          },

          {
            path: 'i/:instanceId/workflows/agents/:agentId/:flowId?/builder/*',
            element: <InstanceAgentBuilderPage />
          },

          {
            path: 'i/:instanceId',
            element: <InstanceRedirect />
          },

          {
            path: 'i/:instanceId',
            element: <InstancePageLayout />,

            children: [
              {
                path: 'settings',
                element: <InstanceSettingsPageLayout />,

                children: [
                  {
                    path: '',
                    element: <InstanceSettingsPage />
                  },

                  {
                    path: 'environments',
                    element: <InstanceSettingsEnvironmentsPage />
                  }
                ]
              },

              {
                path: 'developer',
                element: <InstanceDeveloperPageLayout />,

                children: [
                  {
                    path: '',
                    element: <InstanceDeveloperPage />
                  },
                  {
                    path: 'environments',
                    element: <InstanceDeveloperEnvironmentsPage />
                  },
                  {
                    path: 'api',
                    element: <InstanceDeveloperAPIPage />
                  }
                ]
              },

              {
                path: 'developer',
                element: <InstanceDeveloperLogsLayoutPage />,

                children: [
                  // {
                  //   path: 'events',
                  //   element: <InstanceDeveloperEventsPage />
                  // },
                  // {
                  //   path: 'requests',
                  //   element: <InstanceDeveloperRequestsPage />
                  // }
                ]
              }
            ]
          },

          {
            path: 'i/:instanceId/workflows',
            element: <InstancePageLayout />,

            children: [
              {
                path: '',
                element: <InstanceHomePage />
              },

              {
                path: 'statistics',
                element: <InstanceStatisticsPage />
              },

              {
                path: 'groups/:groupId',
                element: <InstanceGroupLayoutPage />,
                children: [
                  {
                    path: '',
                    element: <InstanceGroupOverviewPage />
                  },
                  {
                    path: 'threads',
                    element: <GroupThreadsPage />
                  },
                  {
                    path: 'users',
                    element: <GroupUsersPage />
                  }
                ]
              },

              {
                path: 'users/:userId',
                element: <InstanceUserLayoutPage />,
                children: [
                  {
                    path: '',
                    element: <InstanceUserPage />
                  },
                  {
                    path: 'groups',
                    element: <InstanceUserGroupsPage />
                  }
                ]
              },

              {
                path: 'agents/choose',
                element: <InstanceAgentsChoosePage />
              },

              {
                element: <InstanceDataPageLayout />,

                children: [
                  {
                    path: 'threads',
                    element: <InstanceThreadsPage />
                  },
                  {
                    path: 'runs',
                    element: <InstanceRunsPage />
                  },
                  {
                    path: 'users',
                    element: <InstanceUsersPage />
                  },
                  {
                    path: 'groups',
                    element: <InstanceGroupsPage />
                  }
                ]
              },

              {
                path: 'agents',
                element: <InstanceAgentsPageLayout />,

                children: [
                  {
                    path: '',
                    element: <InstanceAgentsPage />
                  },
                  {
                    path: 'templates',
                    element: <InstanceAgentTemplatesPage />
                  },
                  {
                    path: 'connections',
                    element: <InstanceAgentConnectionsPage />
                  }
                ]
              },

              {
                path: 'agents/:agentId',
                children: [
                  {
                    path: '',
                    element: <InstanceAgentLayoutPage />,

                    children: [
                      {
                        path: '',
                        element: <InstanceAgentOverviewPage />
                      },
                      {
                        path: 'settings',
                        element: <InstanceAgentSettingsPage />
                      },
                      {
                        path: 'runs',
                        element: <InstanceAgentRunsPage />
                      },
                      {
                        path: 'releases',
                        element: <InstanceAgentReleasesPage />
                      }
                    ]
                  }
                ]
              },

              {
                path: 'portals',
                element: <InstancePortalsPageLayout />,

                children: [
                  {
                    path: '',
                    element: <InstancePortalsPage />
                  }
                ]
              },

              {
                path: 'portals/:portalId',
                element: <InstancePortalLayoutPage />,

                children: [
                  {
                    path: '',
                    element: <InstancePortalOverviewPage />
                  },
                  {
                    path: 'environments',
                    element: <InstancePortalEnvironmentsPage />
                  },
                  {
                    path: 'domains',
                    element: <InstancePortalDomainsPage />
                  },
                  {
                    path: 'agents',
                    element: <InstancePortalAgentsPage />
                  },
                  {
                    path: 'branding',
                    element: <InstancePortalBrandingPage />
                  },

                  {
                    path: 'settings',
                    element: <InstancePortalSettingsLayout />,

                    children: [
                      {
                        path: '',
                        element: <InstancePortalSettingsPage />
                      },
                      {
                        path: 'auth',
                        element: <InstancePortalSettingsAuthPage />
                      }
                    ]
                  }
                ]
              },

              {
                children: [
                  {
                    path: 'threads/:threadId',
                    element: <InstanceThreadLayoutPage />,

                    children: [
                      {
                        path: '',
                        element: <InstanceThreadPage />
                      },
                      {
                        path: 'runs',
                        element: <InstanceThreadRunsPage />
                      },
                      {
                        path: 'participants',
                        element: <InstanceThreadParticipantsPage />
                      },
                      {
                        path: 'flow',
                        element: <InstanceThreadFlowPage />
                      }
                    ]
                  }
                ]
              },

              {
                path: 'connections',

                children: [
                  {
                    path: 'choose',
                    element: <InstanceConnectionChoosePage />
                  },
                  {
                    path: 'set',
                    element: <InstanceConnectionSetPage />
                  },
                  {
                    path: ':connectionId',
                    element: <InstanceConnectionLayoutPage />,
                    children: [
                      {
                        path: '',
                        element: <InstanceConnectionsOverviewPage />
                      },
                      {
                        path: 'configuration',
                        element: <InstanceConnectionsConfigurationPage />
                      },
                      {
                        path: 'settings',
                        element: <InstanceConnectionsSettingsPage />
                      },
                      {
                        path: 'access',
                        element: <InstanceConnectionsAccessPage />
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },

      {
        path: 'oauth/callback/:provider',
        element: <InstanceConnectionOauthCallbackPage />
      }
    ]
  }
]);

export let App = () => {
  return <RouterProvider router={router} fallbackElement={<NotFound />} />;
};
